import { Menu } from "lucide-react";
import { Logo } from "./Logo";
import { Profile } from "./Profile";
import { Navigation } from "./Navigation";
import * as Collapsible from "@radix-ui/react-collapsible";
import { Button } from "../Button";
import {
  authSurfaceGradientClass,
  authSurfaceGlowOverlayClass,
  authSurfaceVignetteOverlayClass,
} from "../auth-layout/authStyles";

export function Sidebar() {
  return (
    <Collapsible.Root
      className={`relative z-30 flex shrink-0 flex-col overflow-hidden border-b border-white/5 ${authSurfaceGradientClass} shadow-sidebar data-[state=open]:fixed data-[state=open]:inset-0 data-[state=open]:z-40 lg:sticky lg:top-0 lg:z-30 lg:h-dvh lg:max-h-dvh lg:border-b-0 lg:border-r lg:border-white/5 lg:data-[state=open]:static lg:data-[state=open]:inset-auto`}
    >
      <div className={authSurfaceGlowOverlayClass} aria-hidden />
      <div className={authSurfaceVignetteOverlayClass} aria-hidden />

      <div className="relative z-10 flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto overscroll-contain p-4 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-white/10 lg:px-4 lg:py-7 xl:px-5">
        <div className="flex items-center justify-between gap-2">
          <Logo />
          <Collapsible.Trigger asChild className="lg:hidden">
            <Button
              variant="ghost"
              className="text-white hover:bg-white/10 focus-visible:ring-white/30"
              aria-label="Abrir ou fechar menu"
            >
              <Menu className="h-6 w-6" />
            </Button>
          </Collapsible.Trigger>
        </div>

        <Collapsible.Content
          asChild
          forceMount
          className="data-[state=closed]:hidden data-[state=closed]:animate-slideUpAndFade data-[state=open]:animate-slideDownAndFade lg:data-[state=closed]:flex"
        >
          <div className="flex min-h-0 flex-1 flex-col gap-8">
            <Navigation />

            <div className="mt-auto flex flex-col gap-5">
              <div className="h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
              <Profile />
            </div>
          </div>
        </Collapsible.Content>
      </div>
    </Collapsible.Root>
  );
}
